export default __webpack_public_path__ + "static/media/mask_group_15-33.607db4df.png";